import "./styles.css";
import { FC } from "react";
import NoDataImage from "./images/noDataFount.svg";
import { Box } from "@mui/material";

type NoDataProps = {
  className?: string;
};

const NoDataFound: FC<NoDataProps> = ({ className }) => {
  return (
    <Box>
      <img
        src={NoDataImage}
        alt="NoDataImage"
        className={`noData ${className ? className : ""}`}
      />
    </Box>
  );
};

export default NoDataFound;
